import { render, staticRenderFns } from "./ProductRemoveAction.vue?vue&type=template&id=1268436c"
import script from "./ProductRemoveAction.vue?vue&type=script&lang=js"
export * from "./ProductRemoveAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports